<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <vs-button
              @click="isShowCreatePopup()"
              class="bg_l_green"
              icon-pack="feather"
              icon="icon-plus"
              v-has-permission="permission310"
            >
              {{ $t("CreateNewTransportFleet") }}
            </vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :columns="[
                { title: $t('Title') },
                { title: $t('CreatorUser') },
                { title: $t('CreateOn') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 30%">{{ row.name }}</td>
                <td style="width: 35%">{{ row.creatorUserId }}</td>
                <td style="width: 15%">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <create-popup
          :show="onShowCreatePopup"
          @finish="onfinish"
          @close="closeCreatePopup"
        ></create-popup>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import CreatePopup from "./CreatePopup.vue";

export default {
  name: "",
  components: {
    DataGrid,
    CreatePopup,
  },
  data() {
    return {
      permission310: "CreateTransportFleet",
      onShowCreatePopup: false,
      gridDataSource: {
        type: "app",
        service: "Shipping/api/TransportsFleetQuery",
      },
    };
  },
  methods: {
    isShowCreatePopup() {
      this.onShowCreatePopup = true;
    },
    closeCreatePopup() {
      this.onShowCreatePopup = false;
    },
    onfinish() {
      this.closeCreatePopup();
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 0);
    },
  },
};
</script>
